import { memo } from 'react'
import { useLocation } from 'react-router-dom'
import { Box, Toolbar } from '@mui/material'
import { useCurrentUser } from '~/common/use-current-user'
import { useFeatures } from '~/common/use-features'
import { useAuthContext } from '~/common/context/auth/auth-context'
import { useUserByteSize } from '~/common/use-user-byte-size'
import { useUserFarms } from '~/common/use-user-farms'
import { TicketStatus } from '~/components/ticket-status'
import { useSidebarNav } from './use-sidebar-nav'
import { SidebarMenu } from './sidebar-menu'
import { MobileExtras } from './mobile-extras'
import { StorageUsage } from './storage-usage'
import { VersionFooter } from './version-footer'
import { formatBytes } from './sidebar-constants.jsx'

export const DrawerContent = memo(({ collapsed, isDesktop, onClose }) => {
  const location = useLocation()
  const { currentUser } = useCurrentUser()
  const { features } = useFeatures()
  const { user: authUser, ticketInfo } = useAuthContext()
  const { byteSize } = useUserByteSize({ userId: authUser?.id })
  const { userFarms } = useUserFarms({ user: currentUser })
  const { buildUrl, handleClick } = useSidebarNav({ onClose })

  const isSuperAdmin = currentUser?.permissions === 1
  const layoutExpanded = !isDesktop || !collapsed

  const ticketBottom = isSuperAdmin ? 70 : 10
  const storageBottom = isSuperAdmin ? 68 : 10

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Toolbar />

      {/* Nav menu */}
      <Box>
        <SidebarMenu
          layoutExpanded={layoutExpanded}
          buildUrl={buildUrl}
          handleClick={handleClick}
          features={features}
          location={location}
        />

        {/* Mobile farm selector */}
        <MobileExtras
          isSuperAdmin={isSuperAdmin}
          userFarms={userFarms}
          location={location}
        />
      </Box>

      {/* Ticket status — demo users, expanded only */}
      {ticketInfo && layoutExpanded && (
        <Box sx={{ position: 'absolute', bottom: ticketBottom, left: 0, right: 0 }}>
          <TicketStatus collapsed={isDesktop && collapsed} />
        </Box>
      )}

      {/* Storage usage — all users, expanded only, opt-out via storage_usage flag */}
      {features['storage_usage'] && layoutExpanded && formatBytes(byteSize) != null && (
        <StorageUsage byteSize={byteSize} bottom={storageBottom} fadeSx={{}} />
      )}

      {/* Version footer — admin only, expanded only */}
      {features['version_info'] && layoutExpanded && <VersionFooter fadeSx={{}} />}
    </Box>
  )
})
